import React, { HTMLAttributes, ReactChild } from 'react'

export interface IIconButtonProps extends HTMLAttributes<HTMLTableSectionElement> {
  children: ReactChild | ReactChild[];
  disabled?: boolean;
  hideoutButton?: boolean;
  onClick: () => void;
}
export default function IconButton({children, hideoutButton=false, disabled=false, onClick,  ...props}: IIconButtonProps) {
  return (
    <button className={['button', (hideoutButton? 'button__icon-hideout' : 'button__icon')].join(' ')}
      disabled={disabled} onClick={onClick} >
      {children}
    </button>
  )
}

// {...props}